export const HOTELS_EML_MOBILE = 'MAT_MAT112';
export const XSELL_MKT_CAMPAIGN_MOBILE = 'BAIT_BAIT24M';
export const XSELL_MKT_CAMPAIGN_DESKTOP = 'BAIT_BAIT24';
export const HSA_HOTEL_FUNNEL_MOBILE = 'DPF_DPF2200M';
export const HSA_PRIME_LOGGED_MOBILE = 'DPF_DPF2964M';
export const HSA_HOTEL_FUNNEL_DESKTOP = 'DPF_DPF2200';
export const HSA_PRIME_LOGGED_DESKTOP = 'DPF_DPF2964';
export const FENCED_HOTELS_HOMEPAGE_HOTEL_DEALS = 'MAT_MAT2291';
export const MAT_HOME_DEALS_CAMPAIGN_MOBILE = 'MAT_MAT2481';
export const MAT_HOME_DEALS_CAMPAIGN_DESKTOP = 'MAT_MAT2549';
export const HOMEPAGE_BOLD_HOTEL_AQUISITION_MOBILE = 'MAT_MAT3062';
export const FLIGHT_SUMMARY_HOTELS_MAP_PRIME = 'MAT_MAT3170P';
export const FLIGHT_SUMMARY_HOTELS_MAP_NON_PRIME = 'MAT_MAT3170';
export const FLIGHT_SUMMARY_HOTELS_MAP_META = 'MAT_MAT3221';

export const TEST_SB_AB_MOCK = 'TEST_TEST000';

export const aliases: string[] = [
  HOTELS_EML_MOBILE,
  XSELL_MKT_CAMPAIGN_MOBILE,
  XSELL_MKT_CAMPAIGN_DESKTOP,
  TEST_SB_AB_MOCK,
  HSA_HOTEL_FUNNEL_MOBILE,
  HSA_PRIME_LOGGED_MOBILE,
  HSA_HOTEL_FUNNEL_DESKTOP,
  HSA_PRIME_LOGGED_DESKTOP,
  FENCED_HOTELS_HOMEPAGE_HOTEL_DEALS,
  MAT_HOME_DEALS_CAMPAIGN_MOBILE,
  MAT_HOME_DEALS_CAMPAIGN_DESKTOP,
  HOMEPAGE_BOLD_HOTEL_AQUISITION_MOBILE,
  FLIGHT_SUMMARY_HOTELS_MAP_PRIME,
  FLIGHT_SUMMARY_HOTELS_MAP_NON_PRIME,
  FLIGHT_SUMMARY_HOTELS_MAP_META,
];

interface AliasNames {
  [key: string]: string;
}

export const aliasNames: AliasNames = {
  [HOTELS_EML_MOBILE]: 'HOTELS_EML_MOBILE',
  [TEST_SB_AB_MOCK]: 'TESTING_AB_MOCK_IN_STORYBOOK',
  [XSELL_MKT_CAMPAIGN_MOBILE]: 'XSELL_MKT_CAMPAIGN_MOBILE',
  [XSELL_MKT_CAMPAIGN_DESKTOP]: 'XSELL_MKT_CAMPAIGN_DESKTOP',
  [HSA_PRIME_LOGGED_MOBILE]: 'HSA_PRIME_LOGGED_MOBILE',
  [HSA_HOTEL_FUNNEL_MOBILE]: 'HSA_HOTEL_FUNNEL_MOBILE',
  [HSA_PRIME_LOGGED_DESKTOP]: 'HSA_PRIME_LOGGED_DESKTOP',
  [HSA_HOTEL_FUNNEL_DESKTOP]: 'HSA_HOTEL_FUNNEL_DESKTOP',
  [FENCED_HOTELS_HOMEPAGE_HOTEL_DEALS]: 'FENCED_HOTELS_HOMEPAGE_HOTEL_DEALS',
  [MAT_HOME_DEALS_CAMPAIGN_MOBILE]: 'MAT_HOME_DEALS_CAMPAIGN_MOBILE',
  [MAT_HOME_DEALS_CAMPAIGN_DESKTOP]: 'MAT_HOME_DEALS_CAMPAIGN_DESKTOP',
  [HOMEPAGE_BOLD_HOTEL_AQUISITION_MOBILE]:
    'HOMEPAGE_BOLD_HOTEL_AQUISITION_MOBILE',
  [FLIGHT_SUMMARY_HOTELS_MAP_PRIME]: 'FLIGHT_SUMMARY_HOTELS_MAP_PRIME',
  [FLIGHT_SUMMARY_HOTELS_MAP_NON_PRIME]: 'FLIGHT_SUMMARY_HOTELS_MAP_NON_PRIME',
  [FLIGHT_SUMMARY_HOTELS_MAP_META]: 'FLIGHT_SUMMARY_HOTELS_MAP_META',
};
